var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4155 1.8531C10.806 1.46258 10.806 0.829414 10.4155 0.438889C10.025 0.048365 9.3918 0.048365 9.00128 0.438889L5.35422 4.08595L1.70716 0.438889C1.31663 0.048365 0.683467 0.048365 0.292943 0.438889C-0.0975814 0.829414 -0.0975814 1.46258 0.292943 1.8531L3.94 5.50016L0.292893 9.14727C-0.0976308 9.5378 -0.0976312 10.171 0.292893 10.5615C0.683417 10.952 1.31658 10.952 1.70711 10.5615L5.35422 6.91438L9.00133 10.5615C9.39185 10.952 10.025 10.952 10.4155 10.5615C10.8061 10.171 10.8061 9.5378 10.4155 9.14727L6.76843 5.50016L10.4155 1.8531Z",
    fill: "#EF102A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red-cross.903dc71f3f8e1f6f0cd3f396bfa35809.svg";
export { ForwardRef as ReactComponent };